function updateMediaBigButtons() {
    document.querySelectorAll(".media-big").forEach(module => {
        module.querySelectorAll(".media-big__item").forEach(item => {
            const button = item.querySelector<HTMLElement>(".media-big__pause");
            if (!button) return;

            // Wir suchen zuerst das sichtbare Element (Bild oder Video-Placeholder)
            let image = item.querySelector<HTMLElement>(".media-big__image, .media-big__video-placeholder, video, iframe");
            if (!image) return;

            const rect = image.getBoundingClientRect();
            const buttonHeight = button.offsetHeight;
            const viewportCenter = window.innerHeight / 2 - buttonHeight / 2;
            const maxOffset = image.offsetHeight - buttonHeight;

            if (rect.bottom < 0) {
                // Bild/Video schon oben vorbei
                button.style.top = `${maxOffset}px`;
            } else if (rect.top > window.innerHeight) {
                // Bild/Video noch nicht erreicht
                button.style.top = `0px`;
            } else {
                // Bild/Video sichtbar → Button mittig mitscrollen
                let offset = viewportCenter - rect.top;
                offset = Math.min(Math.max(offset, 0), maxOffset); // clamp
                button.style.top = `${offset}px`;
            }

            // Button horizontal zentrieren
            button.style.left = "50%";
            button.style.transform = "translateX(-50%)";
            button.style.position = "absolute";
        });
    });
}

window.addEventListener("scroll", updateMediaBigButtons);
window.addEventListener("load", updateMediaBigButtons);
